import type { Product } from '@@partner:types:app'

import React from 'react'
import { notify, notifyError } from '@@partner:helpers/notification'
import { ProductWithoutPreviewFilter, useFetchProductWithoutPreview } from '@@partner:graphql/query/product/productWithoutPreview'

import { Button, Message } from 'rsuite'
import AppLoader from '@components/common/AppLoader'
import DropzoneUploader from '@components/common/form/DropzoneUploader'

import { UPLOAD_NAME_PRODUCT_PREVIEW } from '@@partner:config/product'
import { API_URL_UPLOAD_PRODUCT_PREVIEW } from '@@partner:config/api'

export interface NoPreviewProductUploaderProps {
  filter: ProductWithoutPreviewFilter
  onResetFilter: () => void
  onSkipProduct: (product: Product) => void
  onSuccessUpload: (product: Product) => void
}

const NoPreviewProductUploader: React.FC<NoPreviewProductUploaderProps> =  ({
  filter = {},
  onResetFilter,
  onSkipProduct,
  onSuccessUpload
}) => {
  const { data, loading, error } = useFetchProductWithoutPreview(filter as ProductWithoutPreviewFilter)

  if (loading) {
    return <AppLoader.Spinner center content="Загрузка продукта" />
  }

  if (error) {
    return <Message type="error"><p>Ошибка загрузки продукта <Button color="red" onClick={ onResetFilter }>Сбросить фильтр</Button></p></Message>
  }

  const product = data?.productWithoutPreview

  // product not found
  if (!product || !product.id) {
    return <Message type="warning"><p>По заданным фильтрам ничего не найдено! <Button color="red" onClick={ onResetFilter }>Сбросить фильтр</Button></p></Message>
  }

  const productPkg = product.pkg ? product.pkg : product.weight
  const copyText = product.name + ', ' + productPkg

  const handleCopyToClipboard = (copyText: string) => {
    navigator.clipboard.writeText(copyText).then(() => notify('Скопировано в буфер')).catch(() => notifyError('Не удалось скопировать в буфер'))
  }

  const handleUploadError = () => {
    notifyError('Ошибка загрузки')
  }

  const handleSuccessUpload = () => {
    onSuccessUpload(product)
  }

  const handleSkipClick = () => {
    onSkipProduct(product)
  }

  return <>
    <div className="inline-block">
      <h1 className="text-2xl inline">{ product.xid } { product.name }, { productPkg }</h1>
      <Button color="blue" className="inline-block ml-8" onClick={() => handleCopyToClipboard(copyText)}>Копировать</Button>
    </div>

    <div>
      { product.eans.map(ean => ean.ean).join(',')}
    </div>

    <div className="Picture__DragnDrop">
      <DropzoneUploader
        name={UPLOAD_NAME_PRODUCT_PREVIEW}
        action={API_URL_UPLOAD_PRODUCT_PREVIEW}
        onUploaded={handleSuccessUpload}
        onError={handleUploadError}
        multiple={false}
      />
    </div>
    <div className="mt-4 text-center">
      <Button className="ml-4" color="green" onClick={ handleSkipClick }>Дальше</Button>
    </div>
  </>
}

export default NoPreviewProductUploader